import React from 'react';

import classNames from 'classnames';
import {ComposedChart, Line, ReferenceLine, ResponsiveContainer} from 'recharts';

import {IChartDataProps, IChartLayerProps} from '../chart/chart';
import {getColorByCode} from '../helpers';

export interface IMiniChartProps {
    data: IChartDataProps[];
    id: string;
    className?: string;
    lines?: IMiniChartLayerProps[];
}

export interface IMiniChartLayerProps extends IChartLayerProps {
    color: TMiniChartLineColor;
}

export type TMiniChartLineColor = 'red' | 'green';

const MiniChart = (props: IMiniChartProps): JSX.Element => {
    const className: string = classNames(
        'mini-chart',
        props.className,
    );

    const renderLines: (lines: IMiniChartLayerProps[]) => JSX.Element[] = (lines: IMiniChartLayerProps[]) => (
        lines.map((line: IMiniChartLayerProps, i: number) => (
            <Line
                connectNulls={true}
                dataKey={line.key}
                dot={false}
                key={'line-' + i}
                stroke={getColorByCode(line.color)}
                strokeWidth={1}
                type="linear"
            />
        ))
    );

    return (
        <ResponsiveContainer
            aspect={4}
            className={className}
            debounce={50}
            id={props.id}
            minWidth="70px"
            width="100%"
        >
            <ComposedChart
                data={props.data}
            >
                <ReferenceLine
                    stroke="#bec4dc"
                    strokeDasharray="4 4"
                    strokeWidth={1}
                    y={0}
                />
                {props.lines && renderLines(props.lines)}
            </ComposedChart>
        </ResponsiveContainer>
    );
};

export default MiniChart;
